var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('contactWeb'):_vm._e(),(_vm.isMobile)?_c('contactMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }